const Flickity = require('flickity');
require('flickity-as-nav-for');
const dotSliders = document.querySelectorAll('.standardSlider');
const buttonSliders = document.querySelectorAll('.buttonSlider');
const mobSliders = document.querySelectorAll('.mobSlider');

if (dotSliders) {

    dotSliders.forEach( (item) => {
		let flky = new Flickity( item, {
			accessibility: true,
			prevNextButtons: false,
			pageDots: true,
			imagesLoaded: true,
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            draggable: false,
            autoPlay: 5000,
		})

		window.addEventListener('load', () => {
			flky.resize();
		})
	})
}

if (buttonSliders) {

    buttonSliders.forEach( (item) => {
        const wrapper = item.closest('.twinSlider')

        const sliderPrev = wrapper.querySelector('.sliderPrev');
        const sliderNext = wrapper.querySelector('.sliderNext');

        // this is the slider image nav
        const nav = wrapper.querySelector('.asForNav')

        let flky = new Flickity( item, {
            accessibility: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            draggable: false,
            autoPlay: false,
        })

        let flkyNav = new Flickity( nav, {
            accessibility: true,
            prevNextButtons: false,
            ImagesLoaded: true,
            pageDots: false,
            cellAlign: 'center',
            contain: true,
            asNavFor: item,
        })

        sliderPrev.addEventListener('click', () => {
            flky.previous();
        });

        sliderNext.addEventListener('click', () => {
            flky.next();
        });

        window.addEventListener('load', () => {
            flky.resize();
        })

        // fix resize bug for image slider nav where height style set to 0px
        function setSliderHeightToMax(nav) {
            nav.cells.forEach(cell => cell.element.style.height = '');

            let heights = nav.cells.map(cell => cell.element.offsetHeight),
                max = Math.max.apply(Math, heights);

            nav.cells.forEach(cell => cell.element.style.height = max + 'px');
        }

        window.addEventListener('resize', () => {
            setSliderHeightToMax(flkyNav);
        });

        window.addEventListener('load', () => {

            setTimeout( () => {
                setSliderHeightToMax(flkyNav);
                flkyNav.resize();
            }, 150);
        });
    })
}

if (mobSliders) {

	mobSliders.forEach( (item) => {
		let flky = new Flickity( item, {
			accessibility: true,
			prevNextButtons: false,
			pageDots: false,
			imagesLoaded: true,
			cellAlign: 'center',
			watchCSS: true,
		})

		window.addEventListener('load', () => {
			flky.resize();
		})
	})
}
